export function ResponseDownload(data: any, fileName: string) {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  const file_name = fileName;
  link.href = url;
  link.setAttribute("download", file_name);
  document.body.appendChild(link);
  link.click();
}
